<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">续约执行</span></div>
            <el-row type="flex" justify="start" style="margin-top: 30px;">
                <el-form label-position="left" inline :model="queryForm" label-width="140px" >
                    <el-form-item label="订单月份">
                        <!-- <el-date-picker
                        style="width:140px;"
                        v-model="searchForm.sDate"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>至
                        <el-date-picker
                        style="width:140px;"
                        v-model="searchForm.eDate"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker> -->
                        <el-date-picker
                            v-model="queryForm.ym"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="选择月份">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <el-button style="margin-left:20px;    height: 2rem;" type="primary" @click="onQuery">检索</el-button>
            </el-row>
            <el-table 
                :data="renewOrderList.slice((currentPage-1)*PageSize,currentPage*PageSize)" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <!-- <el-table-column prop="dataMonth" align="center"  label="数据月份"></el-table-column> -->
                <el-table-column prop="订单日期" align="center"  label="订单日期" ></el-table-column> 
                <el-table-column prop="经销商全称" align="center" label="经销商全称" ></el-table-column> 
                <el-table-column prop="经销商联络人" align="center"  label="经销商联络人" ></el-table-column>
                <el-table-column prop="经销商联络电话" align="center" label="经销商联络电话" ></el-table-column>
                <el-table-column prop="经销商电子邮件" align="center"  label="经销商电子邮件" ></el-table-column>
                <el-table-column prop="终端客户" align="center"  label="终端客户" ></el-table-column>
                <el-table-column prop="终端客户联络人" align="center"  label="终端客户联络人" ></el-table-column>
                <el-table-column prop="终端客户联络电话" align="center"  label="终端客户联络电话" ></el-table-column>
                <el-table-column prop="终端客户电子邮件" align="center"  label="终端客户电子邮件" ></el-table-column>
                <el-table-column prop="终端客户省份" align="center"  label="终端客户省份" ></el-table-column>
                <el-table-column prop="终端客户地址" align="center"  label="终端客户地址" ></el-table-column>
                <el-table-column prop="料号" align="center"  label="料号" ></el-table-column>
                <el-table-column prop="产品名称" align="center"  label="产品名称" ></el-table-column>
                <el-table-column prop="帐单类型" align="center"  label="帐单类型" ></el-table-column>
                <el-table-column prop="数量" align="center"  label="数量" ></el-table-column>
                <el-table-column prop="合约周期-开始" align="center"  label="合约周期-开始" ></el-table-column>
                <el-table-column prop="合约周期-结束" align="center"  label="合约周期-结束" ></el-table-column>
                <el-table-column prop="订单状态" align="center"  label="订单状态" ></el-table-column>
                <el-table-column prop="预约开通日" align="center"  label="预约开通日" ></el-table-column>
                <el-table-column prop="预约关闭日" align="center"  label="预约关闭日" ></el-table-column>
                <!-- <el-table-column prop="续约单号/项次" align="center"  label="续约单号/项次" ></el-table-column> -->
                <el-table-column prop="技术服务支持" align="center"  label="技术服务支持" ></el-table-column>
                <el-table-column prop="订阅时长（月）" align="center"  label="订阅时长（月）" ></el-table-column>
                <el-table-column prop="建立者名称" align="center"  label="建立者名称" ></el-table-column>
                <el-table-column prop="异动者名称" align="center"  label="异动者名称" ></el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-button @click="onOpenDo(scope.row)" type="text" size="small">跟进</el-button>
                        <!-- <el-button type="text" size="small">编辑</el-button> -->
                    </template>
                </el-table-column>
            </el-table>

            <div class="tabListPage">
                <el-pagination @size-change="handleSizeChange" 
                                @current-change="handleCurrentChange" 
                                :current-page="currentPage" 
                                :page-sizes="pageSizes" 
                                :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                                :total="totalCount">
                    </el-pagination>
            </div>
            
        <el-dialog title="跟进订单" :visible="doDialogVisible" width="60%"
                        :modal-append-to-body='false'
                        :close-on-click-modal='false'
                        @close="doDialogVisible = false" 
                        append-to-body>
            <el-form :model="editForm" inline style="margin-top: 30px;">
                <!-- <el-row> -->
                    <el-form-item label="跟进形式">
                        <el-select  placeholder="跟进形式" v-model="editForm.doType"  >
								<el-option
									v-for="item in doTypeList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
                    </el-form-item>
                <!-- </el-row>
                <el-row> -->
                    <el-form-item v-if="editForm.doType == '电话'" label="通话编号">
						<el-input   placeholder="请输入通话编号" v-model="editForm.sessionCode"></el-input>
					</el-form-item>
                    <el-form-item v-if="editForm.doType == '邮件'" label="发件时间">
						<el-date-picker
                            v-model="editForm.mailTime"
                            type="datetime"
                            placeholder="选择发件时间">
                        </el-date-picker>
					</el-form-item>
                    <el-form-item label="跟进状态">
                        <el-select  placeholder="跟进状态" v-model="editForm.status"  >
								<el-option
									v-for="item in statusList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
                    </el-form-item>
                    <el-form-item label="说明">
						<el-input   placeholder="请输入说明" type="textarea"  :rows="2" v-model="editForm.remark"></el-input>
					</el-form-item>
                    <el-form-item v-if="editForm.status == '完成'" label="跟进结果">
                        <el-select  placeholder="跟进结果" v-model="editForm.result"  >
								<el-option
									v-for="item in resultList"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
                    </el-form-item>
                <!-- </el-row>-->
            </el-form>
            <div >
                <el-divider content-position="left"></el-divider>
                <div slot="footer" style="display:flex;justify-content:center;margin-top:5px;">
                    <el-button @click="doDialogVisible = false">关闭</el-button>
                    <el-button style="margin-left:20px;" type="primary" @click="onSaveImport">保存</el-button>
                </div>
            </div>
            <div>
                <el-divider content-position="center">跟进日志</el-divider>
            </div>
		</el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCurrentYM } from "@/utils/time";
import { getToken } from "@/utils/auth";
// import {uploadFile} from "@/api/file";
import {ImportRenewOrderExcel2Final} from "@/api/workSheet";


export default {
    name: 'baseform',
    components: {

      },
    computed: {
        ...mapGetters(['renewOrderList'])
    },
    data() {
        return {
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:0,
            // 个数选择器（可修改）
            pageSizes:[20,50,100],
            // 默认每页显示的条数（可修改）
            PageSize:50,

            doDialogVisible:false,
            // searchForm:{
            //     sDate:'',
            //     eDate:'',
            // },
            queryForm:{ym:getCurrentYM()},
            editForm:{
                doType:'',
                sessionId:'',
                mailTime:'',
                result:'',
                remark:'',
                status:'',
                planDateArray:[],
            },
            doTypeList:[{label:'电话',value:'电话'},{label:'邮件',value:'邮件'}],
            statusList:[{label:'执行中',value:'执行中'},{label:'完成',value:'完成'}],
            resultList:[{label:'续约',value:'续约'},{label:'不续约',value:'不续约'},{label:'不确定',value:'不确定'}],
            // importLog:[],            
            // importMsg:[],
            importNo:0,
            curImportLog:{},
            // selectedList:[],
        };
    },

    async mounted() {
        // await this.$store.dispatch('zc/orderStatusList');
        // await this.$store.dispatch('zc/productList');
        this.onQuery();
    },


    methods: {
        onOpenDo(){
            this.doDialogVisible=true;
        },

        async onImportClick(){
            
        },

        // 首页检索
       async onQuery(){
        await this.$store.dispatch("workSheet/renewOrderList", {
            ym:this.queryForm.ym
        }).then(res=>{
            this.$refs.Table.doLayout();
            this.totalCount=this.renewOrderList.length
            this.currentPage=1
            
        });

       },

       // 每页显示的条数
        handleSizeChange(val) {
            // 改变每页显示的条数 
            this.PageSize=val
            // 注意：在改变每页显示的条数时，要将页码显示到第一页
            this.currentPage=1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
        },




        getRowKey(row) {
            return row.终端客户;
        },

        handleSelectionChange(val) {	
            this.selectedList = val;				
        },
        
        async onSaveImport(){
            
            await ImportRenewOrderExcel2Final({userId: getToken(),importNo:this.importNo}).then(()=>{
                this.onQuery();
                this.$message.success('导入成功');
                this.doDialogVisible=false;
            });
        },
    }
};
</script>

<style scoped>
</style>